import type { ConditionOperator } from '@ricoh/ria.client.core/constants/core/data.type';

import type { ColorType, ImageEnhanceType, Resolution, Side } from '~/common/model/api/scanning-profile';
import type { BarCodeType, PatchCodeType, StartNewDocumentWhenType } from '~/common/model/api/separation-profile';

/** BarCode types. */
export const BAR_CODE_TYPES: BarCodeType[] = [
  'aztec',
  'codabar',
  'code128',
  'code39',
  'code39Full',
  'code93',
  'dataMatrix',
  'ean13',
  'ean8',
  'interleaved2Of5',
  'microPdf417',
  'microQr',
  'pdf417',
  'postnet',
  'qr',
  'upcA',
  'upcE',
];

/** BarCode name. */
export const BAR_CODE_NAME: Record<BarCodeType, string> = {
  aztec: 'Aztec',
  codabar: 'Codabar',
  code128: 'Code 128',
  code39: 'Code 39',
  code39Full: 'Code 39 Full',
  code93: 'Code 93',
  dataMatrix: 'DataMatrix',
  ean13: 'EAN 13',
  ean8: 'EAN 8',
  interleaved2Of5: 'Interleaved 2 of 5',
  microPdf417: 'Micro PDF 417',
  microQr: 'Micro QR Code',
  pdf417: 'PDF 417',
  postnet: 'POSTNET',
  qr: 'QR',
  upcA: 'UPC-A',
  upcE: 'UPC-E',
} as const;

/** PatchCode types. */
export const PATCH_CODE_TYPES: PatchCodeType[] = ['patchI', 'patchII', 'patchIII', 'patchIV', 'patchT', 'patchVI'];

/** PatchCode name. */
export const PATCH_CODE_NAME: Record<PatchCodeType, string> = {
  patchI: 'Patch Code I',
  patchII: 'Patch Code II',
  patchIII: 'Patch Code III',
  patchIV: 'Patch Code IV',
  patchT: 'Patch Code T',
  patchVI: 'Patch Code VI',
} as const;

/** StartNewDocumentWhenTypes. */
export const START_NEW_DOCUMENT_WHEN_TYPES: StartNewDocumentWhenType[] = ['barCodeTypeIsFound', 'barCodeValueIsChanges', 'barCodeValueIsFound'];

/** BarCode Value Found Operator. */
export const BARCODE_VALUE_FOUND_OPERATORS: ConditionOperator[] = [
  'equals',
  'notEquals',
  'contains',
  'notContains',
  'in',
  'notIn',
  'startsWith',
  'notStartsWith',
  'endsWith',
  'notEndsWith',
  'match',
  'notMatch',
];

/** Resolution. */
export const RESOLUTIONS: Resolution[] = [300, 450, 600];

/** Sides. */
export const SIDES: Side[] = ['singleSided', 'duplex'];

/** Color types. */
export const COLOR_TYPES: ColorType[] = ['auto', 'blackAndWhite', 'color', 'gray'];

/** ImageEnhance types. */
export const IMAGE_ENHANCE_TYPES: ImageEnhanceType[] = ['autoCrop', 'backGroundRemoval', 'autoRotatePages', 'deskew', 'blankPageRemoval', 'despeckle'];
